import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";
import { useFetchChHeatmapDataQuery } from "../../Apis/analyticsApi";
import { useTimeframeSelector } from "../../Hooks/useTimeframeSelector";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import ChHeatmapFilters from "./ChHeatmapFilters";
import ChHeatmapContent from "./ChHeatmapContent";
import { cx } from "../../Util/classHelpers";
import styles from "./chHeatmap.module.css";

const ChHeatmapWrapper = () => {
    const { data: enterpriseAccounts } = useFetchCompanyInfosQuery();

    const [selectedLocations, setSelectedLocations] = useState([]);

    const {
        timeframe,
        dateRange,
        startDate,
        endDate,
        onTimeframeChange,
        onRangeChange,
        onRangeClear,
    } = useTimeframeSelector("thisWeek");

    const companyList = useMemo(() => {
        if (!enterpriseAccounts) return [];
        return enterpriseAccounts.getAccountsArray().map((c) => ({
            id: c.companyId,
            name: c.companyName,
        }));
    }, [enterpriseAccounts]);

    useEffect(() => {
        if (companyList.length > 0 && selectedLocations.length === 0) {
            setSelectedLocations(companyList.map((c) => c.id));
        }
    }, [companyList]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleLocationsChange = useCallback((locations) => {
        setSelectedLocations(locations);
    }, []);

    const skip = selectedLocations.length === 0
        || (timeframe === "range" && (!startDate || !endDate));

    const { data: heatMapData, isFetching } = useFetchChHeatmapDataQuery(
        { companyIds: selectedLocations, timeframe, startDate, endDate },
        { skip }
    );

    const data = heatMapData?.getData() ?? [];

    return (
        <div className={styles.chRoot} style={{ height: "calc(100vh - 180px)", position: "relative" }}>
            <div className={cx("d-flex flex-column gap-4 w-full h-full", isFetching && "disabled-div")}>
                <ChHeatmapFilters
                    companyList={companyList}
                    selectedLocations={selectedLocations}
                    onLocationsChange={handleLocationsChange}
                    timeframe={timeframe}
                    onTimeframeChange={onTimeframeChange}
                    dateRange={dateRange}
                    onRangeChange={onRangeChange}
                    onRangeClear={onRangeClear}
                />
                <ChHeatmapContent data={data} loading={isFetching} />
            </div>
            {isFetching && <LoadingSpinner />}
        </div>
    );
};

export default ChHeatmapWrapper;
